import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=1c3d15d6&scoped=true&"
import script from "./info-card.vue?vue&type=script&lang=js&"
export * from "./info-card.vue?vue&type=script&lang=js&"
import style0 from "./info-card.vue?vue&type=style&index=0&id=1c3d15d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d15d6",
  null
  
)

export default component.exports